import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core'
import React from 'react'

const RadioInput = ({
    handleChange,
    label,
    value,
    options = [],
    disabledValues = [],
    row = false,
    ...props
}) => {

    const RenderOptions = (item, key) => {
        return (
            <FormControlLabel
                key={key}
                disabled={disabledValues.findIndex(eachValue => eachValue === item.value) > -1}
                control={
                    <Radio color='primary' value={item.value} />
                }
                label={item.label}
            />
        )
    }
    return (
        <FormControl component="fieldset" {...props}>
            <FormLabel component="legend" color='primary'>{label}</FormLabel>
            <RadioGroup row={row} aria-label="radio button" value={value} onChange={handleChange}>
                {
                    options.map(RenderOptions)
                }
            </RadioGroup>
        </FormControl>
    )
}

export default RadioInput
